import { GitHubIcon, LinkedInIcon, MailIcon } from "./Icons";
import Image from "./Image";

export default function Hero() {
    return (
        <section className="hero">
            <div className="hero__banner" aria-hidden="true" />

            <Image
                className="hero__avatar"
                src="/avatar.png"
                alt="Alexander Efremidis"
                width={144}
                height={144}
                loading="eager"
                decoding="async"
                fetchPriority="high"
            />

            <div className="hero__identity">
                <h1 className="hero__name">M. Sc. Alexander Efremidis</h1>
                <p className="hero__headline">Cloud Engineer</p>
                <p className="hero__meta">Köngen, Baden-Württemberg, Deutschland</p>
            </div>

            <div className="hero__actions">
                <a
                    className="btn btn--linkedin"
                    href="https://www.linkedin.com/in/alexander-efremidis/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <LinkedInIcon className="btn__icon" />
                    LinkedIn
                </a>
                <a
                    className="btn btn--github"
                    href="https://github.com/DeadP4xel"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <GitHubIcon className="btn__icon" />
                    GitHub
                </a>
                <a className="btn btn--email" href="mailto:alex@efremidis.de">
                    <MailIcon className="btn__icon" />
                    E-Mail
                </a>
            </div>
        </section>
    );
}
